import { Select } from '@mantine/core'

import { useMutation } from '@redwoodjs/web'

import { toast } from 'src/components/Overlays/Toast/Toast'
import { REQUEST_PACKAGES, UPDATE_PACKAGE } from 'src/graphql/packages.graphql'
import { PackageTypeOptions } from 'src/graphql/types/package'

interface TypeCellProps {
  pkg: {
    packageId: string
    packageType: string
  }
}

const TypeCell = ({ pkg }: TypeCellProps) => {
  const [updatePackage] = useMutation(UPDATE_PACKAGE, {
    onCompleted: ({ updatePackage: result }) =>
      toast(`${result.name} updated`, 'success'),
    onError: (e) => toast(e?.message || 'Unable to update package', 'error'),
    // Package has no keyFields in the Apollo cache, so the mutation result
    // does not merge into the packages list on its own.
    refetchQueries: [REQUEST_PACKAGES],
  })

  return (
    <Select
      data={PackageTypeOptions}
      variant="unstyled"
      size="xs"
      value={pkg.packageType}
      onChange={(val) =>
        updatePackage({
          variables: { packageId: pkg.packageId, input: { packageType: val } },
        })
      }
    />
  )
}

export default TypeCell
